import { Component, Input, OnInit } from '@angular/core';
import { MemberCard, MemberCardQuery, MemberQuery } from '@fgb/core';
import { MemberDetails } from '@fgb/core/lib/modules/account/member/models/member-details.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent implements OnInit {
  @Input() isHomePage: boolean = false;
  @Input() bannerTitle: string = '';

  memberDetails$: Observable<MemberDetails | undefined>;
  card$: Observable<MemberCard | undefined>;

  constructor(
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery
  ) {}

  ngOnInit(): void {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectCurrentCard();
  }
}
